import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../../../context";
import KeyPointsRichText from "../../richText/sessionDashboard/KeyPointsRichText";
import StopIcon from "@mui/icons-material/Stop";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import MicIcon from "@mui/icons-material/Mic";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import ActionItemsRichText from "../../richText/sessionDashboard/ActionItemsRichText";
import FollowUpSummaryRichText from "../../richText/sessionDashboard/FollowUpSummaryRichText";
import TestSummaryRichText from "../../richText/sessionDashboard/TestSummaryRichText";
import WorksheetSummaryRichText from "../../richText/sessionDashboard/WorksheetSummaryRichText";
//SpeechRecognition
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { getTranscript, getTranslation } from "../../APIS/clientAPIS";
function FollowUpSummary({
  isWebsocketDataRecieved,
  follow_up_summary,
  sessionStatus,
}) {
  const [autoGenPopup, setAutoGenPopup] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isRecordingStopped, setIsRecordingStopped] = useState(false);
  const [audioRequestData, setAudioRequestData] = useState(null);
  const { expertDashboardData } = useContext(AppContext);
  const handleAutoGenerate = () => {
    setAutoGenPopup(!autoGenPopup);
  };
  useEffect(() => {
    setAutoGenPopup(isWebsocketDataRecieved);
  }, [isWebsocketDataRecieved]);
  // audio recording
  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const recorderControls = useAudioRecorder();

  useEffect(() => {
    const sendAudioData = async () => {
      const base64String = await convertBlobToBase64(
        recorderControls.recordingBlob
      );

      getTranscript(
        expertDashboardData.session_data.appointment_details.appointment_id,
        expertDashboardData.session_data.appointment_details.user_id,
        expertDashboardData.session_data.appointment_details.expert_id,
        expertDashboardData.session_data.appointment_details.appointment_date,
        expertDashboardData.session_data.appointment_details.booking_date,
        base64String
      ).then((res) => {
        getTranslation(
          expertDashboardData.session_data.appointment_details.appointment_id,
          expertDashboardData.session_data.appointment_details.user_id,
          expertDashboardData.session_data.appointment_details.expert_id,
          expertDashboardData.session_data.appointment_details.appointment_date,
          expertDashboardData.session_data.appointment_details.booking_date,
          res.transcript
        );
      });
    };
    if (
      recorderControls.recordingBlob !== undefined &&
      recorderControls.recordingBlob !== null
    ) {
      sendAudioData();
    }
  }, [recorderControls.recordingBlob]);
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split("data:audio/webm;codecs=opus;base64,")[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  const handleRecordingStart = () => {
    recorderControls.startRecording();
    setIsRecording(true);
  };

  const handleRecordingStop = async () => {
    recorderControls.stopRecording();
    setIsRecording(false);
    setIsRecordingStopped(true);
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        {!expertDashboardData?.session_data?.submitted && (
          <div className="d-flex gap-2">
        
            {isRecording ? (
              <button style={{ maxWidth: "fit-content", right: "30px", bottom: "30px", position: "fixed", zIndex: "1000" }}
                className="PrimaryCTA"
                onClick={handleRecordingStop}
              >
                <StopIcon color="#FFF" />
                Stop voice recording
              </button>
            ) : (
              <button style={{ maxWidth: "fit-content", right: "30px", bottom: "30px", position: "fixed", zIndex: "1000" }}
                className="PrimaryCTA"
                onClick={handleRecordingStart}
              >
                <MicIcon color="#FFF" />
                Generate prescription from voice
              </button>
            )}
          </div>
        )}
        {/* hidden for developmen purpose */}
        <div className="d-none gap-3 align-items-center">
          <button
            style={{
              border: "none",
              borderRadius: "5px",
              background: "#FFF",
              color: "#73589b",
            }}
          >
            <DownloadForOfflineIcon style={{ fontSize: "30px" }} />
          </button>
          <button
            style={{
              border: "none",
              borderRadius: "5px",
              background: "#FFF",
              color: "#73589b",
            }}
          >
            <LocalPrintshopIcon style={{ fontSize: "30px" }} />
          </button>
        </div>
      </div>

      <div className="PrescriptionOtherData--Container mt-5 ">
        <div className="OtherData--Item position-relative">
          {autoGenPopup ? (
            <KeyPointsRichText
              sessionStatus={sessionStatus}
              initialText={follow_up_summary?.key_points?.text || ""}
              isWebsocketDataRecieved={isWebsocketDataRecieved}
              aiGenerated={true}
            />
          ) : (
            <KeyPointsRichText
              sessionStatus={sessionStatus}
              aiGenerated={false}
              initialText={""}
              isWebsocketDataRecieved={isWebsocketDataRecieved}
            />
          )}
        </div>
        <div className="OtherData--Item position-relative">
          {autoGenPopup ? (
            <ActionItemsRichText
              sessionStatus={sessionStatus}
              initialText={follow_up_summary?.action_items?.text || ""}
              isWebsocketDataRecieved={isWebsocketDataRecieved}
              aiGenerated={true}
            />
          ) : (
            <ActionItemsRichText
              sessionStatus={sessionStatus}
              aiGenerated={false}
              initialText={""}
              isWebsocketDataRecieved={isWebsocketDataRecieved}
            />
          )}
        </div>
      </div>
      <div className="my-3 ">
        {autoGenPopup ? (
          <FollowUpSummaryRichText
            sessionStatus={sessionStatus}
            initialText={follow_up_summary?.follow_up_summary?.text || ""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
            aiGenerated={true}
          />
        ) : (
          <FollowUpSummaryRichText
            sessionStatus={sessionStatus}
            aiGenerated={false}
            initialText={""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
          />
        )}
      </div>
      <div className="my-3">
        {autoGenPopup ? (
          <TestSummaryRichText
            sessionStatus={sessionStatus}
            initialText={follow_up_summary?.test_summary?.text || ""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
            aiGenerated={true}
          />
        ) : (
          <TestSummaryRichText
            sessionStatus={sessionStatus}
            aiGenerated={false}
            initialText={""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
          />
        )}
      </div>
      <div className="my-3">
        {autoGenPopup ? (
          <WorksheetSummaryRichText
            sessionStatus={sessionStatus}
            initialText={follow_up_summary?.worksheet_summary?.text || ""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
            aiGenerated={true}
          />
        ) : (
          <WorksheetSummaryRichText
            sessionStatus={sessionStatus}
            aiGenerated={false}
            initialText={""}
            isWebsocketDataRecieved={isWebsocketDataRecieved}
          />
        )}
      </div>

    </div>
  );
}

export default FollowUpSummary;
